import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AssembleeLLM from './AssembleeLLM';
import Admin from './pages/Admin';

function App() {
  return (
    <Routes>
      <Route path="/" element={<AssembleeLLM />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

export default App;

